




















































import Component, { mixins } from "vue-class-component";
import { PaymentPackage, PaymentPackageEnum } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import {
  InputSubscriptionLevelCreate,
  InputSubscriptionLevelUpdate,
  SubscriptionLevel,
} from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { UserVerificationStatus } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import WithUserVerification from "@/mixins/WithUserVerification";
import providers from "@/lib/api";
import { CheckAuthoritiesPage } from "@/lib/decorators";
import BaseButtonCreate from "@/components/BaseButtonCreate";
import BasePage from "@/components/BasePage";
import EmptyContent from "@/components/EmptyContent";
import PageTitle from "@/components/PageTitle";
import CreateLevelView from "./components/CreateLevelView.vue";
import EditLevelView from "./components/EditLevelView.vue";
import LevelsView from "./components/LevelsView.vue";
import NoLevelsView from "./components/NoLevelsView.vue";

@CheckAuthoritiesPage(["updateMyContentSubscriptionLevel"])
@Component({
  name: "PageSubscriptionLevels",
  components: {
    EditLevelView,
    CreateLevelView,
    LevelsView,
    NoLevelsView,
    BasePage,
    PageTitle,
    BaseButtonCreate,
    EmptyContent,
  },
})
export default class PageSubscriptionLevels extends mixins(WithUserVerification, WithAuthUser) {
  public approved: boolean = true;
  public priceList: SubscriptionLevel[] = [];
  public packageList: PaymentPackage[] = [];
  public showCreate: boolean = false;
  public priceToEdit: SubscriptionLevel | null = null;
  public loading: boolean = false;
  public saveWelcomeMessage: ((subjectId: string) => Promise<void>) | null = null;

  get showEdit() {
    return !!this.priceToEdit;
  }

  public openEdit(id: string) {
    this.priceToEdit = this.priceList.find(i => i.id === id) || null;
  }

  public closeEdit() {
    this.priceToEdit = null;
  }

  public async createLevel(data: InputSubscriptionLevelCreate) {
    try {
      this.loading = true;
      const { id } = await providers.SubscriptionLevelProvider.create({ data });
      await this.getPrices();
      if (this.saveWelcomeMessage) {
        await this.saveWelcomeMessage(id);
      }
      this.showCreate = false;
    } finally {
      this.loading = false;
    }
  }

  public async updateLevel(data: InputSubscriptionLevelUpdate) {
    try {
      this.loading = true;
      const { id } = await providers.SubscriptionLevelProvider.update({ data });
      if (this.saveWelcomeMessage) {
        await this.saveWelcomeMessage(id);
      }
      await this.getPrices();
      this.closeEdit();
    } finally {
      this.loading = false;
    }
  }

  public async deleteLevel(id: string) {
    await providers.SubscriptionLevelProvider.delete({ id });
    this.closeEdit();
    await this.getPrices();
  }

  public getPrices() {
    return providers.SubscriptionLevelProvider.find({ userIds: [this.authUserStrict.id] }, [
      "id",
      "userId",
      "pricePackageId",
      { pricePackage: ["amount", { costs: ["cost", "currency"] }] },
      "contentCount",
      "description",
    ]).then(r => (this.priceList = r));
  }

  public created() {
    this.getPrices();
    this.approved = this.authUserVerificationStatus === UserVerificationStatus.VERIFIED;
    providers.PaymentPackageProvider.findAll({ type: [PaymentPackageEnum.SUBSCRIPTION] }).then(
      r => (this.packageList = r)
    );
  }
}
